var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallThumbnails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 11.7894h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7891 0h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7891 11.7896h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 5.89478h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.7891 5.89453h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.89453 0h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.89453 11.7896h4.21053v4.21053h-4.21053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.89453 5.89453h4.21053v4.21053h-4.21053z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallThumbnails);
export default __webpack_public_path__ + "static/media/small-thumbnails.b2b972f124a0d8de0da192e42446cefa.svg";
export { ForwardRef as ReactComponent };